<app-header></app-header>

<div class="container" style="height: auto">
  <div class="px-2 py-2 my-2 mb-5 mt-3">
    <h1 class="mb-3 text-heading" style="color: #0e0e0e">Let's get started</h1>
    <p class="h6 text-center mb-5" style="font-size: 16px; color: #0e0e0e">
      Please fill out all the required details
    </p>
    <div class="col-lg-6 mx-auto">
      <form [formGroup]="signupForm" #form="ngForm" (keydown.enter)="addUser()">
        <!-- <form [formGroup]="signupForm"> -->
          <div class="row">
            <div class="col mb-2">
              <mat-form-field
                [style.width.%]="100"
                appearance="outline"
                style="color: #0e0e0e"
              >
                <mat-label style="color: #0e0e0e">First Name</mat-label>
                <input
                  matInput
                  formControlName="firstName"
                  placeholder="Juan"
                />
              </mat-form-field>
              <div *ngIf="signupForm.get('firstName').errors">
                <div
                  class="text text-danger"
                  *ngIf="
                    signupForm.get('firstName').touched &&
                    signupForm.get('firstName').errors.required
                  "
                >
                  First Name is required.
                </div>
              </div>
              <div *ngIf="submitted">
                <div class="text-danger">
                  Please fill in all required fields.
                </div>
              </div>
            </div>
            <div class="col mb-2" style="color: #0e0e0e">
              <mat-form-field [style.width.%]="100" appearance="outline">
                <mat-label>Last Name</mat-label>
                <input
                  matInput
                  formControlName="lastName"
                  placeholder="Dela Cruz"
                />
              </mat-form-field>
              <div *ngIf="signupForm.get('lastName').errors">
                <div
                  class="text text-danger"
                  *ngIf="
                    signupForm.get('lastName').touched &&
                    signupForm.get('lastName').errors.required
                  "
                >
                  Last Name is required.
                </div>
              </div>
            </div>
          </div>
        <mat-form-field [style.width.%]="100" appearance="outline" > 
          <mat-label style="color: #0e0e0e">Email</mat-label>
          <input
            matInput
            type="email"
            formControlName="email"
            placeholder="johndoe@gmail.com"
          />
        </mat-form-field>
        <div *ngIf="signupForm.get('email').errors" class="mb-2">
          <div
            class="text text-danger"
            *ngIf="
              signupForm.get('email').touched &&
              signupForm.get('email').errors.required
            "
          >
            Email is required.
          </div>
          <div
            class="text text-danger"
            *ngIf="signupForm.get('email').errors.pattern"
          >
            Provide a valid email (e.g: juandelacruz@gmail.com)
          </div>
        </div>
        <div>
          <mat-form-field [style.width.%]="100" appearance="outline">
            <mat-label style="color: #0e0e0e">Password</mat-label>
            <input
              matInput
              [type]="hide ? 'password' : 'text'"
              formControlName="password"
            />
            <button
              mat-icon-button
              matSuffix
              (click)="hide = !hide"
              type="button"
            >
              <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
            </button>
          </mat-form-field>
          <div *ngIf="signupForm.get('password').errors" class="mb-2">
            <div
              class="text text-danger"
              *ngIf="
                signupForm.get('password').touched &&
                signupForm.get('password').errors.required
              "
            >
              Password is required.
            </div>
          </div>
        </div>
        <div>
          <mat-form-field [style.width.%]="100" appearance="outline">
            <mat-label style="color: #0e0e0e">Confirm Password</mat-label>
            <input
              matInput
              [type]="hideConfirmation ? 'password' : 'text'"
              formControlName="ConfirmPassword"
            />
            <button
              mat-icon-button
              matSuffix
              (click)="hideConfirmation = !hideConfirmation"
              [attr.aria-label]="'hideConfirmation password'"
              [attr.aria-pressed]="hideConfirmation"
              type="button"
            >
              <mat-icon>{{
                hideConfirmation ? "visibility_off" : "visibility"
              }}</mat-icon>
            </button>
          </mat-form-field>

          <!-- <div
            style="margin-top: 0.5rem; margin-bottom: 0.5rem"
          >
            Password requirement:
            <section>
              <mat-checkbox
                class="example-margin"
                [checked]="
                  passwordControl.value.length >= 8 &&
                  confirmPasswordControl.value.length >= 8
                "
                disabled="true"
              >
                Must be at least 8 characters
              </mat-checkbox>
            </section>
          </div> -->
          <div *ngIf="signupForm.get('ConfirmPassword')!.errors">
            <div
              class="text text-danger mb-2"
              *ngIf="
                signupForm.get('ConfirmPassword')!.touched &&
                signupForm.get('ConfirmPassword')!.errors.required
              "
            >
              Confirm password is required.
            </div>
            <div
              class="text text-danger mb-2"
              *ngIf="
                signupForm.get('password').value.length >= 8 &&
                signupForm.get('ConfirmPassword').value.length >= 8 &&
                signupForm.get('ConfirmPassword')!.errors
                  .ConfirmPasswordValidator
              "
            >
              Passwords did not match. Try again.
            </div>
          </div>
        </div>
        <button
          mat-raised-button
          color="primary"
          class="text-white mb-3 mt-3"
          style="padding-left: 0px; padding-right: 0px"
          [style.width.%]="100"
          (click)="addUser()"
          [disabled]="isDisabled"
          
        >
          <ng-container *ngIf="!isLoading; else loadingContent">
            Register
          </ng-container>
        </button>

        <ng-template #loadingContent>
          <button
            mat-raised-button
            color="primary"
            class="text-white"
            [style.width.%]="100"
            type="button"
            [disabled]="isDisabled"
          >
            Your account is being created
          </button>
        </ng-template>

        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

        <p class="mt-3 text-center">
          <a href="/login"
            >Already have an account? <strong>Login here</strong></a
          >
        </p>
        <div class="row">
          <div style="text-align: center">
            <hr style="background: #00943a; height: 2px" />
            <span
              style="
                position: relative;
                top: -1.7em;
                background-color: white;
                padding: 0 10px;
              "
            >
              OR
            </span>
          </div>
          <p>
            <button
              mat-stroked-button
              type="button"
              color="google"
              (click)="tryGoogle()"
            >
              <mat-icon *ngIf="isLoadingGoogle">
                <mat-spinner
                  diameter="20"
                  style="
                    height: 24px;
                    width: 24px;
                    position: absolute;
                    top: 12px;
                    stroke: #00943a;
                  "
                ></mat-spinner>
              </mat-icon>
              <mat-icon matPrefix *ngIf="!isLoadingGoogle"
                ><img src="assets/google.png" class="social-media-icons" alt=""
              /></mat-icon>
              <span *ngIf="!isLoadingGoogle">Continue with Google</span>
            </button>
          </p>
        </div>
      </form>
    </div>
  </div>
</div>

<app-footer></app-footer>
